import RootStore from './Root.store';

export const store = new RootStore();
